export class FacilityAutocompleteModel {
  id: number;
  facilityNumber: string;
  clientName: string;
  clientId: number;

  constructor(id: number, facilityNumber: string, clientName: string, clientId: number) {
    this.id = id;
    this.facilityNumber = facilityNumber;
    this.clientName = clientName;
    this.clientId = clientId;
  }
}
